/* QLTCHECKERS */
export const GET_QLTCHECKERS = "GET_QLTCHECKERS"
export const GET_QLTCHECKERS_SUCCESS = "GET_QLTCHECKERS_SUCCESS"
export const GET_QLTCHECKERS_FAIL = "GET_QLTCHECKERS_FAIL"

/* QLTCHECKERS DETAIL*/
export const GET_QLTCHECKER_DETAIL = "GET_QLTCHECKER_DETAIL"
export const GET_QLTCHECKER_DETAIL_SUCCESS = "GET_QLTCHECKER_DETAIL_SUCCESS"
export const GET_QLTCHECKER_DETAIL_FAIL = "GET_QLTCHECKER_DETAIL_FAIL"

/**
 * add QLTCHECKER
 */
export const CREATE_QLTCHECKER = "CREATE_QLTCHECKER"
export const CREATE_QLTCHECKER_SUCCESS = "CREATE_QLTCHECKER_SUCCESS"
export const CREATE_QLTCHECKER_FAIL = "CREATE_QLTCHECKER_FAIL"

/**
 * Edit QLTCHECKER
 */
export const UPDATE_QLTCHECKER = "UPDATE_QLTCHECKER"
export const UPDATE_QLTCHECKER_SUCCESS = "UPDATE_QLTCHECKER_SUCCESS"
export const UPDATE_QLTCHECKER_FAIL = "UPDATE_QLTCHECKER_FAIL"

/**
 * Delete QLTCHECKER
 */
export const DELETE_QLTCHECKER = "DELETE_QLTCHECKER"
export const DELETE_QLTCHECKER_SUCCESS = "DELETE_QLTCHECKER_SUCCESS"
export const DELETE_QLTCHECKER_FAIL = "DELETE_QLTCHECKER_FAIL"
